import { useLayoutEffect, useRef } from 'react';

/**
 * Textarea com altura dinâmica: cresce conforme o texto é digitado,
 * evitando scroll interno e facilitando a escrita de textos longos no fluxo.
 *
 * Aceita as mesmas props de um <textarea> nativo. `minRows` define a
 * altura mínima (padrão 2 linhas).
 */
export default function AutoGrowTextarea({ value, minRows = 2, className = '', style, onChange, ...rest }) {
  const ref = useRef(null);

  const resize = () => {
    const el = ref.current;
    if (!el) return;
    el.style.height = 'auto';
    el.style.height = `${el.scrollHeight}px`;
  };

  // Reajusta sempre que o valor muda (inclusive em mudanças programáticas)
  useLayoutEffect(() => {
    resize();
  }, [value]);

  return (
    <textarea
      ref={ref}
      rows={minRows}
      value={value}
      onChange={(e) => {
        onChange?.(e);
        resize();
      }}
      className={className}
      style={{ overflow: 'hidden', resize: 'none', ...style }}
      {...rest}
    />
  );
}
